import dayjs        from 'dayjs';
import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class ShowModel extends ApiModel {
  static get path() {
    return '/backend/shows/{?id}';
  }

  @computed
  get name(): string {
    return this.get('name', '');
  }

  @computed
  get showName(): string {
    return this.get('name', '');
  }

  @computed
  get securityInstructionsOption(): boolean {
    return this.get('securityInstructionsOption', false);
  }

  @computed
  get standDocumentsOption(): boolean {
    return this.get('standDocumentsOption', false);
  }

  @computed
  get standAddDecoratorOption(): boolean {
    return this.get('standAddDecoratorOption', false);
  }

  @computed
  get mountingAttestationOption(): boolean {
    return this.get('mountingAttestationOption', false);
  }

  @computed
  get externalSync(): boolean {
    return this.get('externalSync', false);
  }

  @computed
  get externalSyncAt(): string | null {
    return this.get('externalSyncAt') ?? null;
  }

  @computed
  get sourceIri(): string {
    return this.get('source.@id');
  }

  @computed
  get source(): string {
    return this.get('source');
  }

  @computed
  get sourcePath(): string {
    return this.get('sourcePath');
  }

  @computed
  get externalExhibitorAccessUrl(): string {
    return this.get('externalExhibitorAccessUrl');
  }

  @computed
  get enabled(): boolean {
    return this.get('enabled', false);
  }

  @computed
  get logoIri(): string {
    return this.get('logo.@id');
  }

  @computed
  get logoMediaFileName(): string {
    return this.get('logo.mediaFileName');
  }

  @computed
  get exhibitorGuideIri(): string {
    return this.get('exhibitorGuide.@id');
  }

  @computed
  get exhibitorGuideMediaFileName(): string {
    return this.get('exhibitorGuide.mediaFileName');
  }

  @computed
  get mapIri(): string {
    return this.get('map.@id');
  }

  @computed
  get mapMediaFileName(): string {
    return this.get('map.mediaFileName');
  }

  @computed
  get securityInstructionsIri(): string {
    return this.get('securityInstructions.@id');
  }

  @computed
  get securityInstructionsMediaFileName(): string {
    return this.get('securityInstructions.mediaFileName');
  }

  @computed
  get installationDateStart(): string {
    return this.get('installationDateStart');
  }

  @computed
  get installationDateStartDate() {
    return this.installationDateStart ? dayjs(this.installationDateStart) : null;
  }

  @computed
  get installationDateEnd(): string {
    return this.get('installationDateEnd');
  }

  @computed
  get installationDateEndDate() {
    return this.installationDateEnd ? dayjs(this.installationDateEnd) : null;
  }

  @computed
  get uninstallationDateStart(): string {
    return this.get('uninstallationDateStart');
  }

  @computed
  get uninstallationDateStartDate() {
    return this.uninstallationDateStart ? dayjs(this.uninstallationDateStart) : null;
  }

  @computed
  get uninstallationDateEnd(): string {
    return this.get('uninstallationDateEnd');
  }

  @computed
  get uninstallationDateEndDate() {
    return this.uninstallationDateEnd ? dayjs(this.uninstallationDateEnd) : null;
  }

  @computed
  get organizerDeadline(): string {
    return this.get('organizerDeadline');
  }

  @computed
  get organizerDeadlineDate() {
    return this.organizerDeadline ? dayjs(this.organizerDeadline) : null;
  }

  @computed
  get organizerId(): id {
    return this.get('organizer.id');
  }

  @computed
  get externalSyncDeadline(): string {
    return this.get('externalSyncDeadline');
  }

  @computed
  get externalSyncDeadlineDate() {
    return this.externalSyncDeadline ? dayjs(this.externalSyncDeadline) : null;
  }

  @computed
  get logoObjectUrl(): string {
    return this.get('logo.objectUrl');
  }

  @computed
  get exhibitorGuideObjectUrl(): string {
    return this.get('exhibitorGuide.objectUrl');
  }

  @computed
  get mapObjectUrl(): string {
    return this.get('map.objectUrl');
  }

  @computed
  get securityInstructionsObjectUrl(): string {
    return this.get('securityInstructions.objectUrl');
  }
}
